import { Drawer, Box } from "@mui/material";
import { FeatureCollection, Point, Polygon, MultiPolygon } from "geojson";
import { useState } from "react";
import GoogleMapComponent from "../../jobsdashboard/GoogleMapComponent";
import JobImportTable, { JobsImportTableProps } from ".";
import "./ImportTableWithMap.css";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface ImportTableWithMapProps extends Omit<JobsImportTableProps, "setDrawerState"> {
	// Remove setDrawerState from the original props since we'll handle it internally
}

export default function ImportTableWithMap(props: ImportTableWithMapProps) {
	const [rightSideDrawerOpen, setRightSideDrawerOpen] = useState(false);
	const [displayBoundaries, setDisplayBoundaries] = useState<
		Record<string, FeatureCollection<Polygon> | FeatureCollection<MultiPolygon>>
	>({});
	const [displayedZones, setDisplayedZones] = useState<
		Record<string, FeatureCollection<Polygon> | FeatureCollection<MultiPolygon>>
	>({});
	const [displayedPoints, setDisplayedPoints] = useState<Record<string, FeatureCollection<Point>>>({});

	return (
		<Box className="import-table-with-map">
			<Box className={rightSideDrawerOpen ? "table-wrapper-drawer-open" : "table-wrapper"}>
				<JobImportTable
					{...props}
					setDrawerState={(open: boolean) => setRightSideDrawerOpen(open)}
					setDisplayBoundaries={setDisplayBoundaries}
					setDisplayedZones={setDisplayedZones}
					setDisplayedPoints={setDisplayedPoints}
					drawerOpen={rightSideDrawerOpen}
				/>
			</Box>
			{/* Right side MUI drawer */}
			<Drawer
				variant="persistent"
				anchor="right"
				open={rightSideDrawerOpen}
				onClose={() => {
					setRightSideDrawerOpen(false);
				}}
			>
				<Box className="map-container">
					<GoogleMapComponent
						showPointsAtZoom={10}
						boundaries={displayBoundaries}
						points={displayedPoints}
						zones={displayedZones}
					/>
				</Box>
			</Drawer>
		</Box>
	);
}
